// extracted by mini-css-extract-plugin
export default {"content":"Rateconfirmation_content__piYJr","content__rate":"Rateconfirmation_content__rate__cIKhj","content__rate_btn":"Rateconfirmation_content__rate_btn__1xyUC"};